import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
    const [expanded, setExpanded] = React.useState([]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(
            isExpanded ? [...expanded, panel] : expanded.filter((item) => item !== panel),
        );
    };

    return (
        <Container
            id="faq"
            sx={{
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 16 },
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 3, sm: 6 },
            }}
        >
            <Typography
                component="h2"
                variant="h4"
                sx={{
                    color: 'text.primary',
                    width: { sm: '100%', md: '60%' },
                    textAlign: { sm: 'left', md: 'center' },
                    fontFamily: 'sans-serif', // Minimalistic font

                }}
            >
                Curious about refrb?
            </Typography>
            <Box sx={{
                width: '100%', fontFamily: 'sans-serif', // Minimalistic font
            }}>
                <Accordion
                    expanded={expanded.includes('panel1')}
                    onChange={handleChange('panel1')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                    >
                        <Typography component="span" variant="subtitle2">
                            How does the buying process work?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant="body2"
                            gutterBottom
                            sx={{
                                maxWidth: {
                                    sm: '100%', md: '70%', fontFamily: 'sans-serif', // Minimalistic font
                                }
                            }}
                        >
                            If you have excess devices (these include: laptops, tablets, phones, and desktops) that you are
                            looking to take out of your inventory, contact us through <Link href="mailto:contactrefrb@gmail.com">contactrefrb@gmail.com</Link>.
                            We will supply a quote for everything and pay you to get rid of your retired devices.
                            {/* You can reach our customer support team by emailing&nbsp;
                            <Link href="mailto:support@email.com">support@email.com</Link>
                            &nbsp;or calling our toll-free number. We&apos;re here to assist you
                            promptly. */}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded.includes('panel2')}
                    onChange={handleChange('panel2')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2d-content"
                        id="panel2d-header"
                    >
                        <Typography component="span" variant="subtitle2">
                            How does the pickup process work?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant="body2"
                            gutterBottom
                            sx={{
                                maxWidth: {
                                    sm: '100%', md: '70%', fontFamily: 'sans-serif', // Minimalistic font
                                }
                            }}
                        >
                            We want to make it as easy as possible to get rid of devices no longer in use. So, we can come to
                            you for pick up, or we can supply a shipping label free of charge. Everything is done at no
                            expsense to you.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded.includes('panel3')}
                    onChange={handleChange('panel3')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3d-content"
                        id="panel3d-header"
                    >
                        <Typography component="span" variant="subtitle2">
                            What exactly do you we do with the devices?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant="body2"
                            gutterBottom
                            sx={{
                                maxWidth: {
                                    sm: '100%', md: '70%', fontFamily: 'sans-serif', // Minimalistic font
                                }
                            }}
                        >
                            Our process for migrating unused devices to low-income countries is made to be as intuitive as possible.
                            We first receive the items from, take inventory of them and inspect what needs some "refrb'in". After this,
                            we completely erase and format drives that contain any data. This is done through a specifc contracted
                            software that offers an incredibly secure approach to formatting data. Once this is done, our refurbishing
                            process begins. Fully refurbished devices are packaged up and prepared for shipping. After all devices are
                            packageed we fill shipping containers with the laptops and send them to distributors overseas. They are
                            then distributed to various institutions across an array of countries.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    expanded={expanded.includes('panel4')}
                    onChange={handleChange('panel4')}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4d-content"
                        id="panel4d-header"
                    >
                        <Typography component="span" variant="subtitle2">
                            Who runs this?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            variant="body2"
                            gutterBottom
                            sx={{
                                maxWidth: {
                                    sm: '100%', md: '70%', fontFamily: 'sans-serif', // Minimalistic font
                                }
                            }}
                        >
                            The business is completely ran by me, Lane, the guy writing this. I am a freshman at Vanderbilt University who has been
                            in this business for over five years. I've taken recycled electronics and put them in the hands of
                            hundreds if not thousands of institutions, churches, students, businesses, and local buyers. I believe in the
                            right to repair and that any device deserves another life. If you are interested in talking or looking to helpout
                            email me at <Link href="mailto:lane@refrb.com">lane.t.burgett[at]vanderbilt[dot]edu</Link>.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Container>
    );
}
